import { useTranslation } from "react-i18next";
import type { WorkspaceEntry } from "../workspace-pages.js";

/** A deep link to a page the caller may not use (ADR-032): the shell stays, the sidebar stays, nothing is stripped. */
export function NotAvailablePage({ entry }: { entry: WorkspaceEntry }) {
  const { t } = useTranslation();
  return (
    <p role="status" className="text-muted-foreground max-w-prose text-sm">
      {t("workspace.notAvailable", { page: t(entry.labelKey) })}
    </p>
  );
}
